import React, { useEffect, useRef } from 'react';
import '../Styles/Carousel.css';  // Import your CSS file

const Carousel = ({ supportedNetworks, velocity }) => {
  const carouselRef = useRef(null);

  useEffect(() => {
    const carousel = carouselRef.current;
    let isCancelled = false;

    if (carousel) {
      const scrollWidth = carousel.scrollWidth;
      const clientWidth = carousel.clientWidth;
      let scrollPosition = 0;

      const step = () => {
        if (!isCancelled) {
          scrollPosition += velocity*0.3;
          if (scrollPosition >= scrollWidth - clientWidth) {
            scrollPosition = 0;
          }
          carousel.scrollTo(scrollPosition, 0);
          window.requestAnimationFrame(step);
        }
      };

      window.requestAnimationFrame(step);
    }

    return () => {
      isCancelled = true;
    };
  }, [velocity, supportedNetworks.length]);

  return (
    <div className="carousel" ref={carouselRef}>
      <div className="carousel-content">
        {supportedNetworks.map((network, index) => (
          <div key={index} className="carousel-item">
            {network}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;